import _filter from "lodash/filter";
import { RATE_TYPE_FIXED_30, RATE_TYPE_FIXED_30_FHA, RATE_TYPE_FIXED_30_VA, RATE_TYPE_FIXED_30_JUMBO, RATE_TYPE_FIXED_20, RATE_TYPE_FIXED_15, RATE_TYPE_FIXED_15_JUMBO, RATE_TYPE_FIXED_10, RATE_TYPE_ARM_3_1, RATE_TYPE_ARM_7_1, RATE_TYPE_ARM_5_1_JUMBO, RATE_TYPE_ARM_5_1 } from '@nerdwallet/home-constants';
import styles from '../components/rate-chart/rate-chart.module.less';
var ratesConfig = [// the order of this array is the same order it will be displayed on the table
{
  homeownershipKey: RATE_TYPE_FIXED_30,
  className: styles.FRM30,
  label: '30-year fixed-rate',
  chartLabel: '30-year fixed',
  chart: true
}, {
  homeownershipKey: RATE_TYPE_FIXED_20,
  label: '20-year fixed-rate'
}, {
  homeownershipKey: RATE_TYPE_FIXED_15,
  className: styles.FRM15,
  label: '15-year fixed-rate',
  chartLabel: '15-year fixed',
  chart: true
}, {
  homeownershipKey: RATE_TYPE_FIXED_10,
  label: '10-year fixed-rate'
}, {
  homeownershipKey: RATE_TYPE_ARM_7_1,
  label: '7-year ARM'
}, {
  homeownershipKey: RATE_TYPE_ARM_5_1,
  className: styles.ARM,
  label: '5-year ARM',
  chartLabel: '5-year ARM',
  chart: true
}, // className is only needed for custom styles
// this is only for the rate trends chart which only has the 3 values above with chart = true
// zillow does not have a Jumbo option for their rates api https://mortgageapi.zillow.com/api/getRates
{
  homeownershipKey: RATE_TYPE_ARM_5_1_JUMBO,
  label: '5-year ARM jumbo'
}, {
  homeownershipKey: RATE_TYPE_ARM_3_1,
  label: '3-year ARM'
}, {
  homeownershipKey: RATE_TYPE_FIXED_30_FHA,
  label: '30-year fixed-rate FHA'
}, {
  homeownershipKey: RATE_TYPE_FIXED_30_VA,
  label: '30-year fixed-rate VA'
}, {
  homeownershipKey: RATE_TYPE_FIXED_30_JUMBO,
  label: '30-year fixed-rate jumbo'
}, {
  homeownershipKey: RATE_TYPE_FIXED_15_JUMBO,
  label: '15-year fixed-rate jumbo'
}];
export var ratesChartConfig = _filter(ratesConfig, 'chart');
export default ratesConfig;